import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const ActionButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
`
